import { render, staticRenderFns } from "./detailTabStatus.vue?vue&type=template&id=58f71dbc"
import script from "./detailTabStatus.vue?vue&type=script&lang=js"
export * from "./detailTabStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports